"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
function isArrayRule(rule) {
    return rule.type === "array";
}
function isObjectRule(rule) {
    return rule.type === "object";
}
/**
 * Parse input rule object
 */
var RulesParser = /** @class */ (function () {
    function RulesParser() {
        this.$validTypeSlugs = [
            "string",
            "number",
            "date",
            "boolean",
            "array",
            "object",
        ];
    }
    RulesParser.prototype.isTypeRule = function (rule) {
        return this.$validTypeSlugs.includes(rule);
    };
    RulesParser.prototype.parse = function (input) {
        var _this = this;
        var rawMap = Object.keys(input).reduce(function (acc, path) {
            var rules = _this.getRulesFromExpression(input[path]);
            acc[path] = {
                path: path,
                type: rules.find(function (rule) { return _this.isTypeRule(rule); }),
                rules: rules.filter(function (rule) { return !_this.isTypeRule(rule); }),
            };
            return acc;
        }, {});
        Object.keys(rawMap)
            .filter(function (path) { return /[^\\]\./.test(path); })
            .forEach(function (path) {
            _this.mergeWildcardToParents(path, rawMap);
        });
        return Object.keys(rawMap)
            .filter(function (path) { return !/[^\\]\./.test(path); })
            .reduce(function (acc, path) {
            acc[path.replace(/\\\./g, ".")] = rawMap[path];
            return acc;
        }, {});
    };
    RulesParser.prototype.getRulesFromExpression = function (expression) {
        if (!expression)
            return [];
        if (Array.isArray(expression))
            return expression;
        return expression.split("|");
    };
    RulesParser.prototype.mergeWildcardToParents = function (path, rawMap) {
        var parentPath = this.getParentPath(path);
        if (parentPath) {
            if (!rawMap[parentPath]) {
                rawMap[parentPath] = {
                    path: parentPath,
                    type: undefined,
                    rules: [],
                };
                this.mergeWildcardToParents(parentPath, rawMap);
            }
            if (!rawMap[parentPath].type) {
                if (path.endsWith("*")) {
                    rawMap[parentPath].type = "array";
                }
                else {
                    rawMap[parentPath].type = "object";
                }
            }
            var rule = rawMap[parentPath];
            if (isArrayRule(rule)) {
                rule.of = rawMap[path];
            }
            if (isObjectRule(rule)) {
                if (!rule.shape) {
                    rule.shape = {};
                }
                rule.shape[path.substr(parentPath.length + 1).replace(/\\\./g, ".")] = rawMap[path];
            }
        }
    };
    RulesParser.prototype.getParentPath = function (path) {
        var lastDotWithoutBackslashIndex = -1;
        var regex = /[^\\]\./g;
        while (regex.exec(path) !== null) {
            lastDotWithoutBackslashIndex = regex.lastIndex - 1;
        }
        if (lastDotWithoutBackslashIndex === -1)
            return null;
        return path.substr(0, lastDotWithoutBackslashIndex);
    };
    return RulesParser;
}());
exports.default = new RulesParser();
